@if (shouldShowEnvBanner) {
    <div class="top-header-wrapper">
        <span class="env-banner-text">{{ envBannerText }}</span>
    </div>
}